const defaultOptions = {
  prefix: 'Gs ',
  suffix: '',
  placeholder: 'Gs 0.00',
};

export const formatAmount = (
  value: string | number,
  options?: Partial<typeof defaultOptions>
): string => {
  const { placeholder, prefix, suffix } = {
    ...defaultOptions,
    ...options,
  };

  const formattedValue = `${prefix}${value}${suffix}`;

  return value ? formattedValue : placeholder;
};

export const formatAmountWithUndefined = (
  value: string | number | undefined | null,
  options?: Partial<typeof defaultOptions>
): string => {
  if (value !== undefined && value !== null) {
    return formatAmountWithCents(Number(value));
  } else {
    return '';
  }
};

export const formatAmountWithCents = (value: number): string => {
  const formatNumber = Number(value).toFixed(2).replace('.', ',');
  const [integerPart, decimalPart] = formatNumber.split(',');
  const integerPartWithDots = integerPart
    .split('')
    .reverse()
    .reduce((acc, num, i) => {
      return num + (i && i % 3 === 0 ? '.' : '') + acc;
    }, '');

  const result = integerPartWithDots + ',' + decimalPart;

  return formatAmount(result).toString();
};
